import { FC } from 'react';
import { NEWBUILDING_MONTHLY_PAYMENT } from 'shared/constants/experiments';
import { useExperiment, useRuntimeSetting } from 'shared/hooks';
import { MortgageSearchTypeContainer } from './inner/MortageSearchTypeContainer';

export const MortgagePromoSearchTypeContainer: FC = () => {
  const isNewBuildingMonthlyPaymentExperimentEnabled = useExperiment(NEWBUILDING_MONTHLY_PAYMENT);
  const isEnabled = useRuntimeSetting('Newbuilding.MortgageMonthlyPayment.Enabled', false);

  if (isNewBuildingMonthlyPaymentExperimentEnabled && isEnabled) {
    return null;
  }

  return <MortgageSearchTypeContainer />;
};
